export * from './IconDetail'
